import { PillProps } from "@theorgchartdev/storybook/dist/components/Pill/Pill";
import { SubmissionStatus } from "./PlanSubmisionsTypes";
import { IconName, IconProps } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

const PlanSubmissionsPillColors: Record<SubmissionStatus, PillProps["color"]> = {
  [SubmissionStatus.Submitted]: "info",
  [SubmissionStatus.Approved]: "success",
  [SubmissionStatus.Rejected]: "error",
  [SubmissionStatus.Draft]: "neutral",
  [SubmissionStatus.Withdrawn]: "neutral"
};

export const getSubmissionPillColors = (status: string): PillProps["color"] => {
  if (status in PlanSubmissionsPillColors) {
    return PlanSubmissionsPillColors[status as SubmissionStatus];
  } else {
    return PlanSubmissionsPillColors[SubmissionStatus.Draft];
  }
};

// Need to add new icons to storybook for submitted and withdrawn
// Also need "info" modifier for submitted
const PlanSubmissionsIcon: Record<SubmissionStatus, { name: IconName; color: IconProps["color"] }> =
  {
    [SubmissionStatus.Submitted]: { name: "inbox-out", color: "info" },
    [SubmissionStatus.Approved]: { name: "circle-check", color: "success" },
    [SubmissionStatus.Rejected]: { name: "circle-xmark", color: "error" },
    [SubmissionStatus.Draft]: { name: "file-pen", color: "secondary" },
    [SubmissionStatus.Withdrawn]: { name: "inbox-in", color: "secondary" }
  };

export const getSubmissionsIcon = (
  status: string
): { name: IconName; color: IconProps["color"] } => {
  if (status in PlanSubmissionsIcon) {
    return PlanSubmissionsIcon[status as SubmissionStatus];
  } else {
    return PlanSubmissionsIcon[SubmissionStatus.Draft];
  }
};

const StatusDisplayMap: Record<SubmissionStatus, string> = {
  Submitted: "In Review",
  Approved: "Approved",
  Rejected: "Rejected",
  Withdrawn: "Withdrawn",
  Draft: "Draft"
};

export const getSubmissionStatusDisplayName = (status: SubmissionStatus): string => {
  return appstr(StatusDisplayMap[status] ?? StatusDisplayMap[SubmissionStatus.Draft]);
};
